<template>
  <div class="toolbox">
    <order ref="productRef"/>
    <orderList ref="orderRef"/>
    <his ref="HisRef"/>
    <ul>
      <li>
        <upload></upload>
        <img src="@/assets/images/tool1.png" />
        <div class="tit">相册/相机</div>
      </li>
      <!-- <li>
        <img src="@/assets/images/tool2.png" />
        <div class="tit">拍摄</div>
      </li> -->
      <li @click="store.seeOP('order',true);orderRef.init()" v-if='!getQueryString("uuid")'>
        <img src="@/assets/images/tool3.png" />
        <div class="tit">订单</div>
      </li>
      <li @click="store.seeOP('product',true);productRef.init()"  v-if='!getQueryString("uuid")'>
        <img src="@/assets/images/tool4.png" />
        <div class="tit">商品</div>
      </li>

      <li @click="store.seeOP('his',true);HisRef.loadData()">
        <img src="@/assets/images/tool5.png" />
        <div class="tit">聊天记录</div>
      </li>   
     </ul>
    <!-- <VEmojiPicker></VEmojiPicker> -->
  </div>
</template>
<script setup>
import {ref,onUnmounted} from 'vue';
import upload from './upload.vue';
import orderList from './order/list.vue';
import order from './order/index.vue'
import his from './history.vue'
import { useSocket } from "@/stores/index";
import { getQueryString } from '@/assets/js/index'
const HisRef=ref(null)
const orderRef=ref(null)
const productRef=ref(null)
const store = useSocket()
onUnmounted(()=>{
  store.visible('his',false);
  if(HisRef.value){
    HisRef.value.rest()
  }
})
</script>
<style lang="scss" scoped>
  .toolbox {
    box-sizing: border-box;
    /* border-bottom: 1px solid #cccccc; */
    background-color: #F2F2F2;
    width: 100%;
    /* height: 170px; */
    overflow-y: scroll;
    position: relative;
    // top: -132px;
    left: 0;
    padding: 20px 0;
    text-align: left;
    ul {
      display: flex;
      padding: 0 28px;
      li {
        width: 62px;
        margin-right: 30px;
        list-style: none;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
        }
        .tit {
          font-size: 12px;
          color: #656565;
          line-height: 17px;
          text-align: center;
          margin-top: 8px;
        }
      }
    }
  }
</style>